import { emailValidation, PhoneFormatter, phoneValidation } from "utils";

interface IACCOUNT_DETAILS_FORM {
  label: string;
  name: string;
  placeholder: string;
  inputType: "number" | "text" | "password" | "date";
  width?: string;
  isCountryCodeVisible?: boolean;
  isError?: true;
  errorMessage?: string;
  validation?: (data: any) => any;
  value: string | number;
  type?: string;
  countryCode?: string;
  formatter?: (data: any) => any;
  emailValidation?: (data: any) => any;
  numberValidation?: (data: any) => any;
  numberFormatter?: (data: any) => any;    
}

export const SIGNUP_FORM: IACCOUNT_DETAILS_FORM[] = [
  {
    label: "First Name",
    name: "firstName",
    placeholder: "Enter First Name",
    type: "input",
    width: "calc(50% - 8px)",
    inputType: "text",
    value: "",
    validation: (str: string) => {
      if (!str) {
        return {
          isError: true,
          errorMessage: "Please Enter Valid First Name",
        };
      }
      if (str.length < 3) {
        return {
          isError: true,
          errorMessage: "Please Enter Valid First Name",
        };
      }
      return {
        isError: false,
        errorMessage: "",
      };
    },
  },

  {
    label: "Last Name",
    name: "lastName",
    placeholder: "Enter Last Name",
    type: "input",
    width: "calc(50% - 8px)",
    inputType: "text",
    value: "",
    validation: (str: string) => {
      if (!str) {
        return {
          isError: true,
          errorMessage: "Please Enter Valid Last Name",
        };
      }
      if (str.length < 2) {
        return {
          isError: true,
          errorMessage: "Please Enter Valid Last Name",
        };
      }
      return {
        isError: false,
        errorMessage: "",
      };
    },
  },
  {
    label: "Mobile Number",
    name: "phone",
    placeholder: "",
    type: "input",
    isCountryCodeVisible: true,
    inputType: "text",
    errorMessage: "Please fix length",
    countryCode: "+1",
    value: "",
    width: "100%",
    validation: (str: string) => {
      return phoneValidation(str);
    },
    formatter: (data: { value: string; countryCode: string }) => {
      const phoneFormatter = new PhoneFormatter();
      const formattedPhone = phoneFormatter.formatPhone(
        data.value,
        data.countryCode
      );
      return {
        formatted: formattedPhone ?? data.value,
        ...data,
        validationInput: formattedPhone?.replace(/\D/g, "") ?? data.value,
      };
    },
  },
  {
    label: "Email",
    name: "email",
    placeholder: "",
    inputType: "text",
    errorMessage: "Please fix length",
    value: "",
    type: "input",
    width: "100%",
    validation: (str: string) => {
      return emailValidation(str);
    },
  },
];


export const ISSKIPWEBAUTHN = true;